import React, { useState } from 'react';
import { Bot, Play, Pause, Settings, CheckCircle, XCircle, Clock, Database, RefreshCw, Plus, Edit, Trash, ArrowRight, Globe, MousePointer, Type, Camera, FileText, ArrowLeft } from 'lucide-react';
export function RegistrationRPA() {
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showAddStepModal, setShowAddStepModal] = useState(false);
  const [viewingLogs, setViewingLogs] = useState(null);
  const [selectedLog, setSelectedLog] = useState(null);
  const workflows = [{
    id: 1,
    name: 'Epic EHR Patient Sync',
    description: 'Automates the process of logging into Epic EHR and creating a new patient entry',
    steps: 14,
    created: '11/01/2025',
    status: 'active',
    lastRun: '2 mins ago',
    successRate: '98%',
    icon: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uqubFG1jX9pJLkMqAsdzhj/Epic_EHR.webp',
    workflowSteps: [{
      id: 1,
      type: 'navigate',
      title: 'Navigate to Login Page',
      description: 'Go to Epic EHR login page',
      url: 'https://epic.novocuris.org'
    }, {
      id: 2,
      type: 'type',
      title: 'Enter Username',
      description: 'Type username in login form',
      xpath: '/html/body/div/div/form/input[1]',
      value: 'admin@novocuris.com'
    }, {
      id: 3,
      type: 'type',
      title: 'Enter Password',
      description: 'Type password in login form',
      xpath: '/html/body/div/div/form/input[2]',
      value: '••••••••'
    }, {
      id: 4,
      type: 'click',
      title: 'Click Login Button',
      description: 'Submit login form',
      xpath: '/html/body/div/div/form/button'
    }, {
      id: 5,
      type: 'wait',
      title: 'Wait for Dashboard',
      description: 'Wait for dashboard to load',
      duration: '3s'
    }, {
      id: 6,
      type: 'click',
      title: 'Open Patient Menu',
      description: 'Click on patient management menu',
      xpath: '/html/body/div/nav/ul/li[2]/a'
    }, {
      id: 7,
      type: 'click',
      title: 'Click New Patient',
      description: 'Click new patient button',
      xpath: '/html/body/div/main/div/button'
    }, {
      id: 8,
      type: 'type',
      title: 'Enter First Name',
      description: 'Type patient first name',
      xpath: '/html/body/div/form/input[1]',
      value: '{{firstName}}'
    }, {
      id: 9,
      type: 'type',
      title: 'Enter Last Name',
      description: 'Type patient last name',
      xpath: '/html/body/div/form/input[2]',
      value: '{{lastName}}'
    }, {
      id: 10,
      type: 'type',
      title: 'Enter Date of Birth',
      description: 'Type patient DOB',
      xpath: '/html/body/div/form/input[3]',
      value: '{{dateOfBirth}}'
    }, {
      id: 11,
      type: 'type',
      title: 'Enter Phone',
      description: 'Type patient phone number',
      xpath: '/html/body/div/form/input[4]',
      value: '{{phone}}'
    }, {
      id: 12,
      type: 'type',
      title: 'Enter Email',
      description: 'Type patient email',
      xpath: '/html/body/div/form/input[5]',
      value: '{{email}}'
    }, {
      id: 13,
      type: 'click',
      title: 'Submit Form',
      description: 'Click submit button',
      xpath: '/html/body/div/form/button[2]'
    }, {
      id: 14,
      type: 'screenshot',
      title: 'Take Confirmation Screenshot',
      description: 'Capture success confirmation'
    }],
    logs: [{
      sessionId: '96f341c9-4797-4a42-be7e-dd81b0e2b767',
      createdAt: '27/11/2025, 12:24:43',
      screenshots: 'Available',
      status: 'success'
    }, {
      sessionId: '85e230b8-3686-3b31-ad6d-cc70a9d1a656',
      createdAt: '27/11/2025, 11:15:22',
      screenshots: 'Available',
      status: 'success'
    }, {
      sessionId: '74d129a7-2575-2a20-9c5c-bb69b8c0b545',
      createdAt: '27/11/2025, 10:05:11',
      screenshots: 'Available',
      status: 'failed'
    }]
  }, {
    id: 2,
    name: 'Insurance Portal Verification',
    description: 'Automates logging into insurance portal and verifying patient coverage',
    steps: 18,
    created: '11/01/2025',
    status: 'active',
    lastRun: '5 mins ago',
    successRate: '95%',
    icon: '🏥',
    logs: [],
    workflowSteps: [{
      id: 1,
      type: 'navigate',
      title: 'Navigate to Insurance Portal',
      description: 'Go to insurance verification portal',
      url: 'https://insurance.provider.com'
    }, {
      id: 2,
      type: 'type',
      title: 'Enter Provider ID',
      description: 'Type provider credentials',
      xpath: '/html/body/div/form/input[1]',
      value: 'PROV-12345'
    }, {
      id: 3,
      type: 'click',
      title: 'Click Login',
      description: 'Submit login form',
      xpath: '/html/body/div/form/button'
    }, {
      id: 4,
      type: 'wait',
      title: 'Wait for Portal Load',
      description: 'Wait for portal to load',
      duration: '2s'
    }, {
      id: 5,
      type: 'click',
      title: 'Open Verification Tool',
      description: 'Click verification menu',
      xpath: '/html/body/div/nav/ul/li[3]/a'
    }]
  }, {
    id: 3,
    name: 'Billing System Entry',
    description: 'Automates creating patient accounts in the billing system',
    steps: 12,
    created: '11/01/2025',
    status: 'paused',
    lastRun: '1 hour ago',
    successRate: '97%',
    icon: '💳',
    logs: [],
    workflowSteps: [{
      id: 1,
      type: 'navigate',
      title: 'Navigate to Billing Portal',
      description: 'Go to billing system',
      url: 'https://billing.novocuris.com'
    }, {
      id: 2,
      type: 'type',
      title: 'Enter Credentials',
      description: 'Type billing system credentials',
      xpath: '/html/body/div/form/input[1]',
      value: 'billing@novocuris.com'
    }, {
      id: 3,
      type: 'click',
      title: 'Login',
      description: 'Submit login',
      xpath: '/html/body/div/form/button'
    }]
  }, {
    id: 4,
    name: 'Patient Portal Setup',
    description: 'Generates patient portal credentials and sends welcome email',
    steps: 8,
    created: '11/01/2025',
    status: 'active',
    lastRun: '10 mins ago',
    successRate: '99%',
    icon: '🔐',
    logs: [],
    workflowSteps: [{
      id: 1,
      type: 'navigate',
      title: 'Navigate to Admin Portal',
      description: 'Go to patient portal admin',
      url: 'https://portal.novocuris.com/admin'
    }, {
      id: 2,
      type: 'click',
      title: 'Create New Account',
      description: 'Click new account button',
      xpath: '/html/body/div/main/button'
    }, {
      id: 3,
      type: 'type',
      title: 'Enter Patient Email',
      description: 'Type patient email',
      xpath: '/html/body/div/form/input[1]',
      value: '{{email}}'
    }]
  }];
  const recentActivity = [{
    id: 1,
    workflow: 'Epic EHR Patient Sync',
    patient: 'Sarah Mitchell',
    action: 'Patient data synced successfully',
    status: 'success',
    timestamp: '2 mins ago',
    duration: '11s'
  }, {
    id: 2,
    workflow: 'Insurance Portal Verification',
    patient: 'James Cooper',
    action: 'Insurance verified - Active coverage',
    status: 'success',
    timestamp: '5 mins ago',
    duration: '16s'
  }, {
    id: 3,
    workflow: 'Patient Portal Setup',
    patient: 'Maria Santos',
    action: 'Portal credentials created and email sent',
    status: 'success',
    timestamp: '10 mins ago',
    duration: '4s'
  }, {
    id: 4,
    workflow: 'Epic EHR Patient Sync',
    patient: 'Robert Chen',
    action: 'Sync failed - Missing required field',
    status: 'error',
    timestamp: '15 mins ago',
    duration: '8s'
  }];
  const stepTypes = [{
    type: 'navigate',
    icon: Globe,
    title: 'Navigate to URL',
    description: 'Navigate to a specific URL'
  }, {
    type: 'click',
    icon: MousePointer,
    title: 'Click Element',
    description: 'Click on an element using XPath'
  }, {
    type: 'type',
    icon: Type,
    title: 'Type Text',
    description: 'Type text into an input field using XPath'
  }, {
    type: 'wait',
    icon: Clock,
    title: 'Wait',
    description: 'Wait for a specified duration'
  }, {
    type: 'screenshot',
    icon: Camera,
    title: 'Take Screenshot',
    description: 'Capture a screenshot of the current page'
  }];
  const getStepIcon = type => {
    const stepType = stepTypes.find(st => st.type === type);
    return stepType ? stepType.icon : Globe;
  };
  // Log Detail View
  if (selectedLog) {
    return <div className="flex flex-col h-full overflow-hidden" data-id="element-1691">
        <div className="mb-6 flex-shrink-0" data-id="element-1692">
          <button onClick={() => setSelectedLog(null)} className="text-sm text-gray-600 hover:text-black mb-4 flex items-center gap-1" data-id="element-1693">
            <ArrowLeft size={16} data-id="element-1694" />
            Back to Logs
          </button>
          <h1 className="text-3xl font-bold tracking-tight mb-2" data-id="element-1695">
            Log Details
          </h1>
          <p className="text-gray-600" data-id="element-1696">Session: {selectedLog.sessionId}</p>
        </div>

        <div className="flex-1 overflow-y-auto space-y-6" data-id="element-1697">
          {/* Session Information */}
          <div className="asika-card p-6" data-id="element-1698">
            <h2 className="font-semibold text-lg mb-4" data-id="element-1699">Session Information</h2>
            <div className="space-y-3" data-id="element-1700">
              <div data-id="element-1701">
                <div className="text-sm text-gray-600" data-id="element-1702">Session ID</div>
                <div className="font-mono text-sm" data-id="element-1703">{selectedLog.sessionId}</div>
              </div>
              <div data-id="element-1704">
                <div className="text-sm text-gray-600" data-id="element-1705">Created At</div>
                <div className="text-sm" data-id="element-1706">{selectedLog.createdAt}</div>
              </div>
            </div>
          </div>

          {/* Log Entries */}
          <div className="asika-card p-6" data-id="element-1707">
            <h2 className="font-semibold text-lg mb-4" data-id="element-1708">Log Entries</h2>
            <div className="text-sm text-gray-600 mb-4" data-id="element-1709">32 log entry(s)</div>
            <div className="bg-gray-50 rounded-lg p-4 font-mono text-xs space-y-2 max-h-96 overflow-y-auto" data-id="element-1710">
              <div data-id="element-1711">Step 1: navigate https://asika.ai/fertilityplusdemo</div>
              <div className="text-gray-600" data-id="element-1712">
                Navigating to https://asika.ai/fertilityplusdemo
              </div>
              <div className="text-green-600" data-id="element-1713">
                Successfully loaded https://asika.ai/fertilityplusdemo
              </div>
              <div className="text-gray-500" data-id="element-1714">
                [Framer On-Page Editing] Unavailable because not on a
                'framer.app' subdomain and access status is no-auth
              </div>
              <div className="text-blue-600" data-id="element-1715">
                Screenshot saved as
                96f341c9-4797-4a42-be7e-dd81b0e2b767-step-1-navigate-https-as.png
              </div>
              <div className="mt-4" data-id="element-1716">Step 2: type Daksh</div>
              <div className="text-gray-600" data-id="element-1717">
                Typed into
                xpath=//*[@id='main']/div[1]/div[1]/form/label[1]/div[2]/input
              </div>
              <div className="text-blue-600" data-id="element-1718">
                Screenshot saved as
                96f341c9-4797-4a42-be7e-dd81b0e2b767-step-2-type-daksh.png
              </div>
              <div className="mt-4" data-id="element-1719">Step 3: type Lal</div>
              <div className="text-gray-600" data-id="element-1720">
                Typed into
                xpath=//*[@id='main']/div[1]/div[1]/form/label[2]/div[2]/input
              </div>
              <div className="text-blue-600" data-id="element-1721">
                Screenshot saved as
                96f341c9-4797-4a42-be7e-dd81b0e2b767-step-3-type-lal.png
              </div>
              <div className="mt-4" data-id="element-1722">
                Step 4: click xpath=//form//input[@name='Male']
              </div>
              <div className="text-gray-600" data-id="element-1723">
                Clicked xpath=//form//input[@name='Male']
              </div>
              <div className="text-blue-600" data-id="element-1724">
                Screenshot saved as
                96f341c9-4797-4a42-be7e-dd81b0e2b767-step-4-click-xpath-form.png
              </div>
            </div>
          </div>

          {/* Screenshots */}
          <div className="asika-card p-6" data-id="element-1725">
            <h2 className="font-semibold text-lg mb-4" data-id="element-1726">Screenshots</h2>
            <div className="text-sm text-gray-600 mb-4" data-id="element-1727">
              10 screenshot(s) available - Play as video
            </div>
            <div className="bg-black rounded-lg aspect-video flex items-center justify-center" data-id="element-1728">
              <div className="text-white text-center" data-id="element-1729">
                <div className="text-6xl mb-4" data-id="element-1730">🎬</div>
                <div className="text-sm" data-id="element-1731">Screenshot preview</div>
              </div>
            </div>
            <div className="flex items-center justify-center gap-4 mt-4" data-id="element-1732">
              <button className="asika-button text-sm" data-id="element-1733">Pause</button>
              <button className="px-4 py-2 border border-gray-300 rounded-full text-sm hover:bg-gray-50" data-id="element-1734">
                Restart
              </button>
              <div className="text-xs text-gray-600" data-id="element-1735">10 frames @ 2 FPS</div>
            </div>
          </div>
        </div>
      </div>;
  }
  // Logs List View
  if (viewingLogs) {
    const workflow = workflows.find(w => w.id === viewingLogs);
    return <div className="flex flex-col h-full overflow-hidden" data-id="element-1736">
        <div className="mb-6 flex-shrink-0" data-id="element-1737">
          <button onClick={() => setViewingLogs(null)} className="text-sm text-gray-600 hover:text-black mb-4 flex items-center gap-1" data-id="element-1738">
            <ArrowLeft size={16} data-id="element-1739" />
            Back to Integration Agent
          </button>
          <h1 className="text-3xl font-bold tracking-tight mb-2" data-id="element-1740">Logs</h1>
          <p className="text-gray-600" data-id="element-1741">View your execution logs</p>
        </div>

        <div className="flex-1 overflow-hidden" data-id="element-1742">
          <div className="asika-card h-full flex flex-col" data-id="element-1743">
            <div className="p-6 border-b border-gray-100 flex items-center justify-between flex-shrink-0" data-id="element-1744">
              <h2 className="text-xl font-bold" data-id="element-1745">Activity Logs</h2>
              <button className="asika-button text-sm" data-id="element-1746">
                <RefreshCw size={14} className="inline mr-2" data-id="element-1747" />
                Refresh
              </button>
            </div>

            {workflow.logs.length === 0 ? <div className="flex-1 flex items-center justify-center" data-id="element-1748">
                <div className="text-center text-gray-500" data-id="element-1749">
                  <FileText size={48} className="mx-auto mb-4 text-gray-300" data-id="element-1750" />
                  <p data-id="element-1751">No logs available for this workflow</p>
                </div>
              </div> : <div className="flex-1 overflow-y-auto" data-id="element-1752">
                <table className="w-full" data-id="element-1753">
                  <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-1754">
                    <tr data-id="element-1755">
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700" data-id="element-1756">
                        Session ID
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700" data-id="element-1757">
                        Created At
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700" data-id="element-1758">
                        Screenshots
                      </th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700" data-id="element-1759">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-1760">
                    {workflow.logs.map(log => <tr key={log.sessionId} className="hover:bg-gray-50" data-id="element-1761">
                        <td className="px-6 py-4" data-id="element-1762">
                          <div className="font-mono text-sm" data-id="element-1763">
                            {log.sessionId}
                          </div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1764">
                          <div className="text-sm" data-id="element-1765">{log.createdAt}</div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1766">
                          <div className="text-sm" data-id="element-1767">{log.screenshots}</div>
                        </td>
                        <td className="px-6 py-4" data-id="element-1768">
                          <button onClick={() => setSelectedLog(log)} className="text-sm text-black hover:underline" data-id="element-1769">
                            View Details
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>}
          </div>
        </div>
      </div>;
  }
  if (selectedWorkflow) {
    const workflow = workflows.find(w => w.id === selectedWorkflow);
    return <div className="flex flex-col h-full overflow-hidden" data-id="element-1770">
        <div className="mb-4 flex items-center justify-between flex-shrink-0" data-id="element-1771">
          <div data-id="element-1772">
            <button onClick={() => setSelectedWorkflow(null)} className="text-black hover:underline text-sm mb-2" data-id="element-1773">
              ← Back to Workflows
            </button>
            <h1 className="text-2xl font-bold tracking-tight" data-id="element-1774">
              {workflow.name}
            </h1>
            <p className="text-muted-foreground" data-id="element-1775">{workflow.description}</p>
          </div>
          <div className="flex items-center gap-2" data-id="element-1776">
            <button className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700" data-id="element-1777">
              <Play size={16} data-id="element-1778" />
              Run Workflow
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-1779">
          {/* Workflow Steps */}
          <div className="bg-white rounded-lg border flex flex-col overflow-hidden" data-id="element-1780">
            <div className="p-4 border-b flex items-center justify-between flex-shrink-0" data-id="element-1781">
              <h2 className="font-semibold" data-id="element-1782">Workflow Steps</h2>
              <button onClick={() => setShowAddStepModal(true)} className="inline-flex items-center gap-1 px-3 py-1 bg-black text-white rounded-md hover:bg-gray-800 text-sm" data-id="element-1783">
                <Plus size={14} data-id="element-1784" />
                Add Step
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-4" data-id="element-1785">
              <div className="space-y-3" data-id="element-1786">
                {workflow.workflowSteps.map((step, index) => {
                const StepIcon = getStepIcon(step.type);
                return <div key={step.id} className="border rounded-md p-3 hover:bg-gray-50" data-id="element-1787">
                      <div className="flex items-start gap-3" data-id="element-1788">
                        <div className="h-8 w-8 rounded bg-purple-100 flex items-center justify-center text-purple-600 font-bold flex-shrink-0" data-id="element-1789">
                          {index + 1}
                        </div>
                        <div className="flex-1" data-id="element-1790">
                          <div className="flex items-center gap-2 mb-1" data-id="element-1791">
                            <StepIcon size={14} className="text-gray-600" data-id="element-1792" />
                            <div className="font-medium text-sm" data-id="element-1793">
                              {step.title}
                            </div>
                          </div>
                          <div className="text-xs text-muted-foreground mb-2" data-id="element-1794">
                            {step.description}
                          </div>
                          {step.url && <div className="text-xs bg-gray-100 rounded px-2 py-1 font-mono" data-id="element-1795">
                              URL: {step.url}
                            </div>}
                          {step.xpath && <div className="text-xs bg-gray-100 rounded px-2 py-1 font-mono mt-1" data-id="element-1796">
                              XPath: {step.xpath}
                            </div>}
                          {step.value && <div className="text-xs bg-gray-100 rounded px-2 py-1 font-mono mt-1" data-id="element-1797">
                              Value: {step.value}
                            </div>}
                          {step.duration && <div className="text-xs bg-gray-100 rounded px-2 py-1 font-mono mt-1" data-id="element-1798">
                              Duration: {step.duration}
                            </div>}
                        </div>
                        <div className="flex items-center gap-1" data-id="element-1799">
                          <button className="p-1 hover:bg-gray-200 rounded" data-id="element-1800">
                            <Play size={14} className="text-green-600" data-id="element-1801" />
                          </button>
                          <button className="p-1 hover:bg-gray-200 rounded" data-id="element-1802">
                            <Settings size={14} data-id="element-1803" />
                          </button>
                          <button className="p-1 hover:bg-gray-200 rounded" data-id="element-1804">
                            <Trash size={14} className="text-red-600" data-id="element-1805" />
                          </button>
                        </div>
                      </div>
                      {index < workflow.workflowSteps.length - 1 && <div className="flex justify-center mt-2" data-id="element-1806">
                          <ArrowRight size={16} className="text-gray-400 rotate-90" data-id="element-1807" />
                        </div>}
                    </div>;
              })}
              </div>
            </div>
          </div>

          {/* Live Browser Preview */}
          <div className="bg-white rounded-lg border flex flex-col overflow-hidden" data-id="element-1808">
            <div className="p-4 border-b flex items-center justify-between flex-shrink-0" data-id="element-1809">
              <div className="flex items-center gap-2" data-id="element-1810">
                <div className="h-2 w-2 rounded-full bg-red-500" data-id="element-1811"></div>
                <h2 className="font-semibold" data-id="element-1812">Live Browser</h2>
              </div>
              <div className="flex items-center gap-2" data-id="element-1813">
                <button className="px-3 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700" data-id="element-1814">
                  <Play size={14} className="inline mr-1" data-id="element-1815" />
                  Run
                </button>
                <button className="px-3 py-1 bg-orange-600 text-white rounded text-sm hover:bg-orange-700" data-id="element-1816">
                  <Pause size={14} className="inline mr-1" data-id="element-1817" />
                  Pause
                </button>
                <button className="px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700" data-id="element-1818">
                  Stop
                </button>
                <button className="px-3 py-1 bg-gray-600 text-white rounded text-sm hover:bg-gray-700" data-id="element-1819">
                  Reset
                </button>
              </div>
            </div>
            <div className="flex-1 bg-gray-900 flex items-center justify-center relative" data-id="element-1820">
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs px-2 py-1 rounded font-bold" data-id="element-1821">
                LIVE
              </div>
              <div className="text-gray-500 text-center" data-id="element-1822">
                <div className="text-4xl mb-2" data-id="element-1823">🖥️</div>
                <div className="text-sm" data-id="element-1824">Browser preview will appear here</div>
                <div className="text-xs mt-1" data-id="element-1825">
                  Click "Run" to start workflow execution
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Step Modal */}
        {showAddStepModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1826">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4" data-id="element-1827">
              <div className="flex items-center justify-between mb-4" data-id="element-1828">
                <h3 className="text-lg font-semibold" data-id="element-1829">Add New Step</h3>
                <button onClick={() => setShowAddStepModal(false)} data-id="element-1830">
                  <XCircle size={20} data-id="element-1831" />
                </button>
              </div>
              <div className="mb-4" data-id="element-1832">
                <input type="text" placeholder="Search for step types..." className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:ring-2 focus:ring-black" data-id="element-1833" />
              </div>
              <div className="grid grid-cols-2 gap-3" data-id="element-1834">
                {stepTypes.map(stepType => <button key={stepType.type} className="flex items-start gap-3 p-4 border rounded-md hover:bg-gray-50 text-left" onClick={() => setShowAddStepModal(false)} data-id="element-1835">
                    <stepType.icon size={20} className="text-blue-600 mt-0.5" data-id="element-1836" />
                    <div data-id="element-1837">
                      <div className="font-medium text-sm" data-id="element-1838">
                        {stepType.title}
                      </div>
                      <div className="text-xs text-muted-foreground" data-id="element-1839">
                        {stepType.description}
                      </div>
                    </div>
                  </button>)}
              </div>
              <p className="text-xs text-muted-foreground mt-4 text-center" data-id="element-1840">
                Select a step type to add it to your workflow. You can configure
                the step details after adding it.
              </p>
            </div>
          </div>}
      </div>;
  }
  return <div className="flex flex-col h-full overflow-hidden" data-id="element-1841">
      <div className="mb-4 flex-shrink-0" data-id="element-1842">
        <h1 className="text-2xl font-bold tracking-tight" data-id="element-1843">Integration Agent</h1>
        <p className="text-muted-foreground" data-id="element-1844">
          Build and monitor your automation workflows with XPath-based
          interactions
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 flex-shrink-0" data-id="element-1845">
        {[{
        icon: Bot,
        color: 'green',
        value: '4',
        label: 'Active Workflows'
      }, {
        icon: CheckCircle,
        color: 'blue',
        value: '97%',
        label: 'Success Rate'
      }, {
        icon: Clock,
        color: 'purple',
        value: '11s',
        label: 'Avg Processing'
      }, {
        icon: Database,
        color: 'orange',
        value: '3,949',
        label: 'Total Syncs'
      }].map((stat, index) => <div key={index} className="bg-white rounded-lg border p-4" data-id="element-1846">
            <div className="flex items-center justify-between mb-2" data-id="element-1847">
              <div className={`h-10 w-10 rounded-lg bg-${stat.color}-100 flex items-center justify-center`} data-id="element-1848">
                <stat.icon className={`text-${stat.color}-600`} size={20} data-id="element-1849" />
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-1850">{stat.value}</div>
            <div className="text-sm text-muted-foreground" data-id="element-1851">{stat.label}</div>
          </div>)}
      </div>

      <div className="flex-1 overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-1852">
        {/* Workflows */}
        <div className="bg-white rounded-lg border flex flex-col overflow-hidden" data-id="element-1853">
          <div className="p-4 border-b flex items-center justify-between flex-shrink-0" data-id="element-1854">
            <h2 className="font-semibold" data-id="element-1855">Workflows</h2>
            <button onClick={() => setShowCreateModal(true)} className="inline-flex items-center gap-1 px-3 py-1 bg-black text-white rounded-md hover:bg-gray-800 text-sm" data-id="element-1856">
              <Plus size={14} data-id="element-1857" />
              New Workflow
            </button>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-1858">
            <div className="divide-y" data-id="element-1859">
              {workflows.map(workflow => <div key={workflow.id} className="p-4 hover:bg-gray-50" data-id="element-1860">
                  <div className="flex items-start gap-3" data-id="element-1861">
                    <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-1862">
                      {typeof workflow.icon === 'string' && workflow.icon.startsWith('http') ? <img src={workflow.icon} alt={workflow.name} className="h-6 w-6" data-id="element-1863" /> : <span className="text-xl" data-id="element-1864">{workflow.icon}</span>}
                    </div>
                    <div className="flex-1" data-id="element-1865">
                      <div className="flex items-center gap-2 mb-1" data-id="element-1866">
                        <button onClick={() => setSelectedWorkflow(workflow.id)} className="font-medium hover:underline text-left" data-id="element-1867">
                          {workflow.name}
                        </button>
                        <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${workflow.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-1868">
                          {workflow.status === 'active' ? 'Active' : 'Paused'}
                        </span>
                      </div>
                      <div className="text-sm text-muted-foreground mb-2" data-id="element-1869">
                        {workflow.description}
                      </div>
                      <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3" data-id="element-1870">
                        <span data-id="element-1871">{workflow.steps} steps</span>
                        <span data-id="element-1872">•</span>
                        <span data-id="element-1873">Created {workflow.created}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1874">
                        <button onClick={() => setSelectedWorkflow(workflow.id)} className="inline-flex items-center gap-1 px-3 py-1 bg-black text-white rounded-md hover:bg-gray-800 text-xs" data-id="element-1875">
                          <Edit size={12} data-id="element-1876" />
                          Edit
                        </button>
                        <button onClick={() => setViewingLogs(workflow.id)} className="inline-flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md hover:bg-gray-50 text-xs" data-id="element-1877">
                          <FileText size={12} data-id="element-1878" />
                          View Logs
                        </button>
                      </div>
                    </div>
                    <button onClick={e => {
                  e.stopPropagation();
                }} className="p-1 hover:bg-gray-200 rounded" title="Delete" data-id="element-1879">
                      <Trash size={16} className="text-red-600" data-id="element-1880" />
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Recent Logs */}
        <div className="bg-white rounded-lg border flex flex-col overflow-hidden" data-id="element-1881">
          <div className="p-4 border-b flex items-center justify-between flex-shrink-0" data-id="element-1882">
            <h2 className="font-semibold" data-id="element-1883">Recent Logs</h2>
            <button className="p-1 hover:bg-gray-100 rounded" data-id="element-1884">
              <RefreshCw size={16} data-id="element-1885" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-1886">
            <div className="divide-y" data-id="element-1887">
              {recentActivity.map(log => <div key={log.id} className="p-4" data-id="element-1888">
                  <div className="flex items-start gap-3" data-id="element-1889">
                    <div className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${log.status === 'success' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-1890">
                      {log.status === 'success' ? <CheckCircle size={16} className="text-green-600" data-id="element-1891" /> : <XCircle size={16} className="text-red-600" data-id="element-1892" />}
                    </div>
                    <div className="flex-1" data-id="element-1893">
                      <div className="font-medium text-sm" data-id="element-1894">{log.workflow}</div>
                      <div className="text-sm text-muted-foreground" data-id="element-1895">
                        {log.patient}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1" data-id="element-1896">
                        {log.action}
                      </div>
                      <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground" data-id="element-1897">
                        <span data-id="element-1898">{log.timestamp}</span>
                        <span data-id="element-1899">•</span>
                        <span data-id="element-1900">{log.duration}</span>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Create Workflow Modal */}
      {showCreateModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-1901">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4" data-id="element-1902">
            <h3 className="text-lg font-semibold mb-4" data-id="element-1903">Create New Workflow</h3>
            <div className="space-y-4" data-id="element-1904">
              <div data-id="element-1905">
                <label className="block text-sm font-medium mb-1" data-id="element-1906">
                  Workflow Name *
                </label>
                <input type="text" placeholder="Enter workflow name (e.g., Login Automation)" className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black" data-id="element-1907" />
              </div>
              <div data-id="element-1908">
                <label className="block text-sm font-medium mb-1" data-id="element-1909">
                  Description (optional)
                </label>
                <textarea placeholder="Describe what this workflow does..." className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm min-h-[100px] focus:outline-none focus:ring-2 focus:ring-black" data-id="element-1910" />
              </div>
              <div className="flex items-center gap-2" data-id="element-1911">
                <button onClick={() => setShowCreateModal(false)} className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800" data-id="element-1912">
                  Create Workflow
                </button>
                <button onClick={() => setShowCreateModal(false)} className="px-4 py-2 border border-input rounded-md hover:bg-gray-50" data-id="element-1913">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}